export const generateKey = (pre: number) => {
  return `${pre + Math.random() * pre}_${new Date().getTime()}`;
};
